import { PhysicalMaterialItem } from './Physical';
import { StandardMaterialItem } from './Standard';
import { BasicMaterialItem } from './Basic';
import { PhongMaterialItem } from './Phong';
import { ToonMaterialItem } from './Toon';

export const MaterialDefinitions = {
  'material.physical': PhysicalMaterialItem,
  'material.standard': StandardMaterialItem,
  'material.basic': BasicMaterialItem,
  'material.phong': PhongMaterialItem,
  'material.toon': ToonMaterialItem,
}; 